import type { JSX } from 'react';
import { memo, useContext } from 'react';

import PersonContext from '@/pages/Person/PersonContext';
import { Props } from '@/pages/Timeline/components/EventTimestamp/types';
import DualTime from '@/ui/components/DualTime/DualTime';

const EventTimestamp = ({ className = '', label, time }: Props): JSX.Element => {
  const {
    person: { time_zone }
  } = useContext(PersonContext);

  return (
    <div className={`text-sm text-gray-600 ${className}`}>
      {label && `${label}: `}
      <DualTime dateTime={new Date(time)} memberTZ={time_zone} />
    </div>
  );
};

export default memo(EventTimestamp);
